const PORTALED_LAYERS = [
  '[data-radix-popper-content-wrapper]',
  '[data-radix-select-content]',
  '[data-radix-menu-content]',
  '[data-radix-dropdown-menu-content]',
  '[data-radix-popover-content]',
  '[role="menu"]',
  '[role="listbox"]',
  '[role="tooltip"]',
  '[data-sonner-toaster]',
  '[data-radix-toast-viewport]',
  'li[role="status"]',
].join(',');

const TOUR_CHROME = [
  '.tour-task-callout',
  '.tour-task-bar',
  '.tour-guide-tracker',
  '.tour-guide-actions',
  '.tour-guide-dock',
  '.driver-popover',
].join(',');

const OPEN_DIALOG = '[role="dialog"], [role="alertdialog"]';

const OWN_DIALOGS = '.driver-popover, .tour-demo-dialog';

const BLOCKED_EVENTS = [
  'pointerdown',
  'mousedown',
  'pointerup',
  'mouseup',
  'click',
  'dblclick',
  'contextmenu',
] as const;

function isOpen(dialog: Element): boolean {
  const state = dialog.getAttribute('data-state');
  if (state && state !== 'open') return false;
  const rect = dialog.getBoundingClientRect();
  return rect.width > 0 || rect.height > 0;
}

function openDialogs(): HTMLElement[] {
  return Array.from(document.querySelectorAll<HTMLElement>(OPEN_DIALOG)).filter(
    (dialog) => !dialog.closest(OWN_DIALOGS) && isOpen(dialog),
  );
}

export function shouldShieldTarget(target: Element | null, current: Element | null): boolean {
  if (!target) return false;

  if (target.closest(TOUR_CHROME)) return false;
  if (target.closest(PORTALED_LAYERS)) return false;
  if (current && (current === target || current.contains(target))) return false;

  const dialogs = openDialogs();

  if (dialogs.length > 0) return !dialogs.some((dialog) => dialog.contains(target));

  return true;
}

export function installBackdropGuard(currentTarget: () => Element | null): () => void {
  const onEvent = (event: Event) => {
    if (!event.isTrusted) return;

    const target = event.target instanceof Element ? event.target : null;
    if (!shouldShieldTarget(target, currentTarget())) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  };

  for (const type of BLOCKED_EVENTS) {
    document.addEventListener(type, onEvent, true);
  }

  return () => {
    for (const type of BLOCKED_EVENTS) {
      document.removeEventListener(type, onEvent, true);
    }
  };
}
